import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocSubtitulo from "../../../utils/MeditocSubtitulo";
import { useColaborador } from "../../../../context/ColaboradorContext";

export default function DetalleColaborador() {
  const {
    colaboradorSeleccionado,
    modalOpenDetalleColaborador,
    handleOpenDetalleColaborador,
  } = useColaborador();

  return (
    <MeditocModal
      title="Detalle de colaborador"
      setopen={handleOpenDetalleColaborador}
      open={modalOpenDetalleColaborador}
      okmessage="Cerrar detalle"
      size="normal"
      hidecancel
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MeditocSubtitulo title="DATOS DEL DIRECTORIO MÉDICO" />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Nombre:"
            value={colaboradorSeleccionado.sNombreDirectorio}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Cédula profesional:"
            value={colaboradorSeleccionado.sCedulaProfecional}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField label="RFC:" value={colaboradorSeleccionado.sRFC} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Teléfono de contacto:"
            value={colaboradorSeleccionado.sTelefonoDirectorio}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="WhatsApp:"
            value={colaboradorSeleccionado.sWhatsApp}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Correo electrónico:"
            value={colaboradorSeleccionado.sCorreoDirectorio}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Especialidad:"
            value={colaboradorSeleccionado.sEspecialidad}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Número de sala IceLink:"
            value={colaboradorSeleccionado.iNumSala}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Dirección de consultorio:"
            value={colaboradorSeleccionado.sDireccionConsultorio}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Nombre de consultorio:"
            value={colaboradorSeleccionado.sNombreConsultorio}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Sitio Web:"
            value={colaboradorSeleccionado.sURL}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Mapa:"
            value={colaboradorSeleccionado.sMaps}
          />
        </Grid>
        <Grid item xs={12}>
          <MeditocSubtitulo title="DATOS DE CUENTA" />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Nombres:"
            value={colaboradorSeleccionado.sNombresDoctor}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Apellido paterno:"
            value={colaboradorSeleccionado.sApellidoPaternoDoctor}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Apellido materno:"
            value={colaboradorSeleccionado.sApellidoMaternoDoctor}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Fecha de nacimiento:"
            value={colaboradorSeleccionado.sFechaNacimientoDoctor}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Teléfono:"
            value={colaboradorSeleccionado.sTelefonoDoctor}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Correo electrónico:"
            value={colaboradorSeleccionado.sCorreoDoctor}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Domicilio particular:"
            value={colaboradorSeleccionado.sDomicilioDoctor}
          />
        </Grid>
        <Grid item xs={12}>
          <MeditocSubtitulo title="USUARIOS" />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Titular:"
            value={colaboradorSeleccionado.sUsuarioTitular}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MeditocInfoField
            label="Administrativo:"
            value={colaboradorSeleccionado.sUsuarioAdministrativo}
          />
        </Grid>
      </Grid>
    </MeditocModal>
  );
}
